import gql from 'graphql-tag'

export const GET_NOTIFICATIONS_LIST = gql`
  query AlertRules($filter: AlertRulesFilter) {
    alertRules(filter: $filter) {
      alertRules {
        data {
          alertRuleId
          label
          companyId
          alertCode
          alert {
            alertCode
            descriptionEng
            descriptionIdn
            alertCategories {
              alertCategoryId
            }
          }
          isActive
          createdOn
          contactRecipients {
            email
            contactId
            label
            phoneNumber
            user {
              fullname
            }
            userId
          }
          maxThreshold
          minThresholdTime
          withSchedule
          startTime
          endTime
          dayOfWeek
          withGeofence
          alertUrgencyType
          isInsideGeofence
          alertCountThreshold
          alertCountWindow
          geofences {
            geofenceId
            serviceLocType
            type
            fenceName
          }
          vehicles {
            id
            licensePlate
          }
          totalVehicles
          totalVgroups
          totalVehiclesInVgroups
          users {
            userId
            fullname
          }
          hasInaccessibleUser
          hasInaccessibleVgroup
          userIsSubscribedToRule
          totalUsers
          autoPopup
          vgroups {
            id
            name
            totalVehicle
          }
          alertFlag
        }
        pagination {
          page
          show
          total
        }
      }
      errorCode
      errorName
      isSuccessful
      message
      status
    }
  }
`

export const GET_RULES_DURATION = gql`
  query AlertRules($filter: AlertRulesFilter) {
    alertRules(filter: $filter) {
      isSuccessful
      message
      alertRules {
        data {
          alertCode
          alertRuleId
          minThresholdTime
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_NOTIFICATIONS_LIST_BY_ID = gql`
  query AlertRule($filter: AlertRuleFilter!) {
    alertRule(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      alertRule {
        alertRuleId
        label
        companyId
        alertCode
        alert {
          alertCode
          descriptionEng
          descriptionIdn
          alertCategories {
            alertCategoryId
          }
        }
        isActive
        alertUrgencyType
        createdOn
        contactRecipients {
          contactId
          email
          label
          phoneNumber
          user {
            fullname
          }
          userId
        }
        withSchedule
        startTime
        endTime
        dayOfWeek
        withGeofence
        isInsideGeofence
        maxThreshold
        minThreshold
        minThresholdTime
        repeatInterval
        alertCountThreshold
        alertCountWindow
        geofences {
          address
          fenceName
          geofenceId
          serviceLocType
          type
        }
        vehicles {
          id
          licensePlate
        }
        totalVehicles
        totalVgroups
        hasInaccessibleVehicle
        users {
          userId
          fullname
        }
        hasInaccessibleUser
        hasInaccessibleVgroup
        userIsSubscribedToRule
        totalUsers
        autoPopup
        vgroups {
          id
          name
          totalVehicle
        }
        alertFlag
      }
    }
  }
`

export const GET_ALERT_CODES_PAGINATED = gql`
  query AlertCodesPaginated($filter: GetAlertCodesInputPaginated) {
    alertCodesPaginated(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      alertCodesPaginated {
        data {
          alertCode
          descriptionEng
          descriptionIdn
          enabledInRule
          fullDescriptionEng
          fullDescriptionIdn
          iconUrl
          alertCategories {
            alertCategoryId
            categoryIdn
            categoryEng
            icon_url
            descriptionIdn
            descriptionEng
          }
        }
        pagination {
          page
          show
          total
          actualTotal
        }
      }
    }
  }
`

export const CREATE_NOTIFICATION_RULES = gql`
  mutation CreateAlertRule($input: CreateAlertRuleInput!) {
    createAlertRule(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createAlertRule {
        alertRuleId
      }
    }
  }
`

export const UPDATE_NOTIFICATION_RULES = gql`
  mutation UpdateAlertRule($input: UpdateAlertRuleInput!) {
    updateAlertRule(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateAlertRule {
        alertRuleId
      }
    }
  }
`

export const DELETE_NOTIFICATION_RULES = gql`
  mutation DeleteAlertRule($input: DeleteAlertRuleInput!) {
    deleteAlertRule(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteAlertRule {
        alertRuleId
      }
    }
  }
`

export const UPDATE_NOTIFICATION_RULES_NEW = gql`
  mutation UpdateAlertRules($input: UpdateAlertRulesInput!) {
    updateAlertRules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateAlertRules {
        count
      }
    }
  }
`

export const DELETE_NOTIFICATION_RULES_NEW = gql`
  mutation DeleteAlertRules($input: DeleteAlertRulesInput!) {
    deleteAlertRules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteAlertRules {
        count
      }
    }
  }
`

export const GET_NOTIFICATION_TEMPLATES = gql`
  query AlertRuleTemplates($filter: AlertRuleTemplatesFilter) {
    alertRuleTemplates(filter: $filter) {
      errorCode
      errorName
      isSuccessful
      message
      status
      alertRuleTemplates {
        data {
          templateId
          category
          nameEng
          nameIdn
          descriptionEng
          descriptionIdn
          iconUrl
          defaultAlertCodes {
            alertCode
            alertRule {
              alertRuleId
              label
            }
            descriptionEng
            descriptionIdn
            enabledInRule
            fullDescriptionEng
            fullDescriptionIdn
            iconUrl
            isAlreadyActive
          }
          additionalAlertCodes {
            alertCode
            alertRule {
              alertRuleId
              label
            }
            descriptionEng
            descriptionIdn
            enabledInRule
            fullDescriptionEng
            fullDescriptionIdn
            iconUrl
            isAlreadyActive
          }
        }
        pagination {
          page
          show
          total
          actualTotal
        }
      }
    }
  }
`

export const CREATE_BULK_NOTIFICATION_RULES = gql`
  mutation CreateAlertRules($input: CreateAlertRulesInput!) {
    createAlertRules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createAlertRules {
        data {
          alert {
            alertCode
            descriptionEng
            descriptionIdn
            fullDescriptionEng
            fullDescriptionIdn
            iconUrl
            enabledInRule
            minThreshold
            maxThreshold
          }
          alertRuleId
          companyId
          createdOn
          label
          startTime
          endTime
          isActive
          minThreshold
          maxThreshold
          withGeofence
          withSchedule
        }
        pagination {
          total
          page
          show
          actualTotal
        }
      }
    }
  }
`

export const GET_ACTIVE_NOTIFICATIONS_LIST = gql`
  query AlertRules($filter: AlertRulesFilter) {
    alertRules(filter: $filter) {
      alertRules {
        data {
          alertRuleId
          isActive
        }
      }
      errorCode
      errorName
      isSuccessful
      message
      status
    }
  }
`
